"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingProvider = void 0;
const React = __importStar(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const reporting_api_1 = require("./reporting-api");
const reporting_context_1 = require("./reporting-context");
function ReportingProvider({ children, url, }) {
    const loadFetch = React.useRef(null);
    const generateFetch = React.useRef(null);
    const loadDefinitions = (0, event_callback_hook_1.useEventCallback)(async () => {
        if (loadFetch.current !== null) {
            loadFetch.current.abort();
        }
        loadFetch.current = (0, reporting_api_1.listReportDefinitions)(url);
        const definitions = await loadFetch.current.json();
        return definitions;
    });
    const generate = (0, event_callback_hook_1.useEventCallback)(async (id, input) => {
        if (generateFetch.current !== null) {
            generateFetch.current.abort();
        }
        generateFetch.current = (0, reporting_api_1.generateReport)(url, id, input !== null && input !== void 0 ? input : {});
        const report = await generateFetch.current.json();
        return report;
    });
    const context = React.useMemo(() => ({
        url,
        loadDefinitions,
        generate,
    }), [url, loadDefinitions, generate]);
    return (React.createElement(reporting_context_1.ReportingContext.Provider, { value: context }, children));
}
exports.ReportingProvider = ReportingProvider;
//# sourceMappingURL=reporting-provider.js.map